export function uid(prefix = 'el') {
  return `${prefix}_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 8)}`
}

export function clone(obj) {
  return JSON.parse(JSON.stringify(obj))
}

export const FONTS = [
  'Montserrat', 'Poppins', 'Playfair Display', 'Oswald', 'Bebas Neue',
  'Anton', 'Lora', 'Raleway', 'Roboto', 'Nunito', 'Pacifico',
  'Dancing Script', 'Merriweather', 'Cormorant Garamond', 'Archivo Black',
]

export const SIZE_PRESETS = [
  { id: 'ig-post', name: 'Instagram Post', w: 1080, h: 1080, group: 'Social' },
  { id: 'ig-story', name: 'Instagram Story', w: 1080, h: 1920, group: 'Social' },
  { id: 'ig-reels', name: 'Instagram Reels', w: 1080, h: 1920, group: 'Social' },
  { id: 'ig-land', name: 'Instagram Landscape', w: 1080, h: 566, group: 'Social' },
  { id: 'fb-post', name: 'Facebook Post', w: 1200, h: 630, group: 'Social' },
  { id: 'fb-cover', name: 'Facebook Cover', w: 1640, h: 924, group: 'Social' },
  { id: 'yt-thumb', name: 'YouTube Thumbnail', w: 1280, h: 720, group: 'Social' },
  { id: 'linkedin', name: 'LinkedIn Post', w: 1200, h: 627, group: 'Social' },
  { id: 'twitter', name: 'X Post', w: 1600, h: 900, group: 'Social' },
  { id: 'present', name: 'Presentation 16:9', w: 1920, h: 1080, group: 'Print' },
  { id: 'poster', name: 'Poster', w: 1587, h: 2245, group: 'Print' },
  { id: 'a4', name: 'A4 Document', w: 2480, h: 3508, group: 'Print' },
  { id: 'logo', name: 'Logo', w: 500, h: 500, group: 'Print' },
  { id: 'card', name: 'Card', w: 1050, h: 600, group: 'Print' },
]

export const BRAND_COLORS = [
  '#0d0c22', '#ffffff', '#8b3dff', '#00c4cc', '#7d2ae8',
  '#ff6a00', '#00c853', '#ff2d55', '#111111', '#f2f2f2',
  '#1a1a2e', '#e8d5b7', '#c9a227', '#0b3d2e', '#f6f1e7',
  '#ff4d6d', '#4cc9f0', '#22223b', '#fefae0', '#606c38',
]

export const PALETTES = [
  { name: 'Bold', colors: ['#0d0c22', '#8b3dff', '#ffffff', '#f3e8ff'] },
  { name: 'Sunset', colors: ['#ff6b35', '#f7c59f', '#efefd0', '#004e89'] },
  { name: 'Forest', colors: ['#081c15', '#2d6a4f', '#d8f3dc', '#fefae0'] },
  { name: 'Noir', colors: ['#000000', '#ffffff', '#ffd60a', '#222222'] },
  { name: 'Blush', colors: ['#ffb3c1', '#ffffff', '#590d22', '#fff0f3'] },
  { name: 'Ocean', colors: ['#023e8a', '#90e0ef', '#caf0f8', '#03045e'] },
]

export const STICKERS = [
  { icon: 'fire', label: 'Fire' },
  { icon: 'wand-magic-sparkles', label: 'Sparkles' },
  { icon: 'heart', label: 'Heart' },
  { icon: 'star', label: 'Star' },
  { icon: 'gift', label: 'Gift' },
  { icon: 'bolt', label: 'Bolt' },
  { icon: 'leaf', label: 'Leaf' },
  { icon: 'gem', label: 'Gem' },
  { icon: 'hand-holding-heart', label: 'Heart hand' },
  { icon: 'bullseye', label: 'Target' },
  { icon: 'check', label: 'Check' },
  { icon: 'camera', label: 'Camera' },
  { icon: 'moon', label: 'Moon' },
  { icon: 'sun', label: 'Sun' },
  { icon: 'music', label: 'Music' },
  { icon: 'flag', label: 'Flag' },
]

const ICON_UNICODE = {
  fire: 'f06d',
  'wand-magic-sparkles': 'e2ca',
  heart: 'f004',
  star: 'f005',
  gift: 'f06b',
  bolt: 'f0e7',
  leaf: 'f06c',
  gem: 'f3a5',
  'hand-holding-heart': 'f4be',
  bullseye: 'f140',
  check: 'f00c',
  camera: 'f030',
  moon: 'f186',
  sun: 'f185',
  music: 'f001',
  flag: 'f024',
}

export function iconUnicode(name) {
  const hex = ICON_UNICODE[name]
  return hex ? String.fromCodePoint(parseInt(hex, 16)) : ''
}

export function textLayer(partial = {}) {
  return {
    id: uid('tx'),
    type: 'text',
    text: 'Add a heading',
    x: 80,
    y: 400,
    width: 920,
    height: 140,
    rotation: 0,
    opacity: 1,
    fontFamily: 'Montserrat',
    fontSize: 72,
    fontWeight: '700',
    fontStyle: 'normal',
    underline: false,
    uppercase: false,
    color: '#0d0c22',
    align: 'center',
    verticalAlign: 'center',
    letterSpacing: 0,
    lineHeight: 1.12,
    shadow: false,
    outline: false,
    outlineColor: '#000000',
    outlineWidth: 4,
    locked: false,
    ...partial,
  }
}

export function shapeLayer(partial = {}) {
  return {
    id: uid('sh'),
    type: 'shape',
    shape: 'rect',
    x: 140,
    y: 140,
    width: 400,
    height: 400,
    rotation: 0,
    opacity: 1,
    fill: '#8b3dff',
    stroke: 'transparent',
    strokeWidth: 0,
    radius: 0,
    locked: false,
    ...partial,
  }
}

export function iconLayer(partial = {}) {
  return {
    id: uid('ic'),
    type: 'icon',
    icon: 'star',
    x: 140,
    y: 140,
    width: 120,
    height: 120,
    rotation: 0,
    opacity: 1,
    color: '#0d0c22',
    locked: false,
    ...partial,
  }
}

export function imageLayer(src, partial = {}) {
  return {
    id: uid('im'),
    type: 'image',
    src,
    x: 0,
    y: 0,
    width: 1080,
    height: 1080,
    rotation: 0,
    opacity: 1,
    filter: 'none',
    brightness: 100,
    contrast: 100,
    saturate: 100,
    locked: false,
    ...partial,
  }
}

export function isVideoSrc(src) {
  const u = String(src || '').split('?')[0].toLowerCase()
  return /\.(mp4|mov|webm|m4v)$/.test(u)
}

export function videoLayer(src, partial = {}) {
  return {
    id: uid('vid'),
    type: 'video',
    src,
    x: 0,
    y: 0,
    width: 1080,
    height: 1080,
    rotation: 0,
    opacity: 1,
    filter: 'none',
    muted: true,
    loop: true,
    paused: false,
    locked: false,
    ...partial,
  }
}

export const SHAPES = [
  { shape: 'rect', label: 'Square', fill: '#8b3dff', radius: 0 },
  { shape: 'rect', label: 'Round', fill: '#00c4cc', radius: 48 },
  { shape: 'ellipse', label: 'Circle', fill: '#ff6a00' },
  { shape: 'triangle', label: 'Triangle', fill: '#ff2d55' },
  { shape: 'star', label: 'Star', fill: '#ffd60a' },
  { shape: 'line', label: 'Line', fill: '#0d0c22', height: 12 },
  { shape: 'rect', label: 'Frame', fill: 'transparent', stroke: '#0d0c22', strokeWidth: 16, radius: 8 },
  { shape: 'ellipse', label: 'Ring', fill: 'transparent', stroke: '#8b3dff', strokeWidth: 24 },
]

export const TEXT_PRESETS = [
  {
    label: 'Add a heading',
    preview: 'Add a heading',
    style: 'heading',
    layer: { text: 'Add a heading', fontFamily: 'Montserrat', fontSize: 80, fontWeight: '800', y: 420, height: 160 },
  },
  {
    label: 'Add a subheading',
    preview: 'Add a subheading',
    style: 'sub',
    layer: { text: 'Add a subheading', fontFamily: 'Montserrat', fontSize: 44, fontWeight: '600', y: 480, height: 90 },
  },
  {
    label: 'Add a little bit of body text',
    preview: 'Add a little bit of body text',
    style: 'body',
    layer: { text: 'Add a little bit of body text', fontFamily: 'Montserrat', fontSize: 28, fontWeight: '400', y: 500, height: 80 },
  },
]

export const TEXT_COMBOS = [
  {
    name: 'Bold launch',
    layers: [
      { text: 'NEW DROP', fontFamily: 'Oswald', fontSize: 28, fontWeight: '600', letterSpacing: 10, uppercase: true, y: 380, height: 50 },
      { text: 'Summer 26', fontFamily: 'Playfair Display', fontSize: 92, fontWeight: '700', y: 440, height: 140 },
    ],
  },
  {
    name: 'Sale stack',
    layers: [
      { text: 'UP TO', fontFamily: 'Montserrat', fontSize: 32, fontWeight: '600', letterSpacing: 8, y: 360, height: 50 },
      { text: '50% OFF', fontFamily: 'Anton', fontSize: 110, fontWeight: '400', y: 420, height: 150 },
    ],
  },
  {
    name: 'Quote',
    layers: [
      { text: '“Create every day.”', fontFamily: 'Playfair Display', fontSize: 56, fontWeight: '700', y: 430, height: 140 },
      { text: '- STUDIO', fontFamily: 'Montserrat', fontSize: 22, fontWeight: '600', letterSpacing: 6, y: 590, height: 40 },
    ],
  },
]

function L(partial) {
  const base = partial.type === 'shape' ? shapeLayer(partial) : textLayer(partial)
  return { ...base, ...partial, id: undefined }
}

export const STARTER_TEMPLATES = [
  {
    name: 'Summer Sale',
    category: 'Marketing',
    width: 1080,
    height: 1080,
    backgroundColor: '#ff6b35',
    thumb: 'linear-gradient(160deg,#ff6b35,#f7c59f)',
    layers: [
      L({ type: 'shape', shape: 'ellipse', fill: '#ffffff', x: -120, y: -80, width: 520, height: 520, opacity: 0.18 }),
      L({ type: 'text', text: 'SUMMER', fontFamily: 'Oswald', fontSize: 42, fontWeight: '600', color: '#fff', letterSpacing: 18, uppercase: true, y: 280, height: 60 }),
      L({ type: 'text', text: 'SALE', fontFamily: 'Anton', fontSize: 180, fontWeight: '400', color: '#fff', y: 340, height: 220 }),
      L({ type: 'text', text: 'UP TO 50% OFF', fontFamily: 'Montserrat', fontSize: 32, fontWeight: '700', color: '#1a1a2e', y: 580, height: 50 }),
      L({ type: 'shape', shape: 'rect', fill: '#1a1a2e', x: 330, y: 700, width: 420, height: 88, radius: 44 }),
      L({ type: 'text', text: 'SHOP NOW', fontFamily: 'Montserrat', fontSize: 28, fontWeight: '800', color: '#fff', y: 718, height: 56, letterSpacing: 4 }),
    ],
  },
  {
    name: 'Quote Card',
    category: 'Quotes',
    width: 1080,
    height: 1080,
    backgroundColor: '#f6f1e7',
    thumb: 'linear-gradient(#f6f1e7,#e8d5b7)',
    layers: [
      L({ type: 'shape', shape: 'rect', fill: 'transparent', stroke: '#1a1a2e', strokeWidth: 4, x: 70, y: 70, width: 940, height: 940, radius: 8 }),
      L({ type: 'text', text: '“', fontFamily: 'Playfair Display', fontSize: 180, fontWeight: '700', color: '#c9a227', y: 180, height: 160 }),
      L({ type: 'text', text: 'Design is\nthinking made\nvisual.', fontFamily: 'Playfair Display', fontSize: 64, fontWeight: '700', color: '#1a1a2e', y: 360, height: 280, lineHeight: 1.15 }),
      L({ type: 'text', text: 'SAUL BASS', fontFamily: 'Montserrat', fontSize: 22, fontWeight: '700', color: '#c9a227', letterSpacing: 8, y: 780, height: 40 }),
    ],
  },
  {
    name: 'Noir Drop',
    category: 'Fashion',
    width: 1080,
    height: 1080,
    backgroundColor: '#0d0c22',
    thumb: 'linear-gradient(#0d0c22,#2a2748)',
    layers: [
      L({ type: 'shape', shape: 'rect', fill: '#ffd60a', x: 80, y: 80, width: 180, height: 8 }),
      L({ type: 'text', text: 'AW26', fontFamily: 'Montserrat', fontSize: 28, fontWeight: '600', color: '#ffd60a', letterSpacing: 10, y: 160, height: 40, align: 'left', x: 80, width: 900 }),
      L({ type: 'text', text: 'NEW\nCOLLECTION', fontFamily: 'Oswald', fontSize: 108, fontWeight: '700', color: '#ffffff', y: 280, height: 280, align: 'left', x: 80, width: 920, lineHeight: 0.95, uppercase: true }),
      L({ type: 'text', text: 'Available this Friday', fontFamily: 'Montserrat', fontSize: 28, fontWeight: '400', color: '#b8b4d0', y: 780, height: 50, align: 'left', x: 80, width: 900 }),
    ],
  },
  {
    name: 'Story Promo',
    category: 'Stories',
    width: 1080,
    height: 1920,
    backgroundColor: '#8b3dff',
    thumb: 'linear-gradient(180deg,#b388ff,#8b3dff)',
    layers: [
      L({ type: 'shape', shape: 'ellipse', fill: '#ffffff', x: 540, y: -200, width: 900, height: 900, opacity: 0.12 }),
      L({ type: 'text', text: 'TODAY ONLY', fontFamily: 'Montserrat', fontSize: 28, fontWeight: '700', color: '#fff', letterSpacing: 10, y: 520, height: 50 }),
      L({ type: 'text', text: 'Flash\nSale', fontFamily: 'Anton', fontSize: 160, fontWeight: '400', color: '#fff', y: 620, height: 360, lineHeight: 0.95 }),
      L({ type: 'shape', shape: 'rect', fill: '#0d0c22', x: 240, y: 1120, width: 600, height: 96, radius: 48 }),
      L({ type: 'text', text: 'SWIPE UP', fontFamily: 'Montserrat', fontSize: 28, fontWeight: '800', color: '#fff', y: 1142, height: 56, letterSpacing: 6 }),
    ],
  },
  {
    name: 'Minimal White',
    category: 'Minimal',
    width: 1080,
    height: 1080,
    backgroundColor: '#ffffff',
    thumb: 'linear-gradient(#ffffff,#f0f0f0)',
    layers: [
      L({ type: 'text', text: 'Hello.', fontFamily: 'Playfair Display', fontSize: 120, fontWeight: '700', color: '#0d0c22', y: 380, height: 160 }),
      L({ type: 'text', text: 'A quiet place to start.', fontFamily: 'Montserrat', fontSize: 28, fontWeight: '400', color: '#737372', y: 560, height: 50 }),
    ],
  },
  {
    name: 'Gradient Mesh',
    category: 'Gradient',
    width: 1080,
    height: 1080,
    backgroundColor: '#7d2ae8',
    thumb: 'linear-gradient(135deg,#7d2ae8,#00c4cc)',
    layers: [
      L({ type: 'shape', shape: 'ellipse', fill: '#00c4cc', x: 480, y: 520, width: 780, height: 780, opacity: 0.55 }),
      L({ type: 'text', text: 'CREATE', fontFamily: 'Bebas Neue', fontSize: 140, fontWeight: '400', color: '#fff', y: 380, height: 170, letterSpacing: 8 }),
      L({ type: 'text', text: 'WITHOUT LIMITS', fontFamily: 'Montserrat', fontSize: 28, fontWeight: '600', color: '#fff', y: 560, height: 50, letterSpacing: 10 }),
    ],
  },
  {
    name: 'Forest Wellness',
    category: 'Lifestyle',
    width: 1080,
    height: 1080,
    backgroundColor: '#081c15',
    thumb: 'linear-gradient(#081c15,#2d6a4f)',
    layers: [
      L({ type: 'shape', shape: 'ellipse', fill: '#2d6a4f', x: 240, y: 200, width: 600, height: 600, opacity: 0.45 }),
      L({ type: 'text', text: 'breathe', fontFamily: 'Dancing Script', fontSize: 120, fontWeight: '700', color: '#d8f3dc', y: 400, height: 160 }),
      L({ type: 'text', text: 'MIND  ·  BODY  ·  RITUAL', fontFamily: 'Montserrat', fontSize: 20, fontWeight: '600', color: '#95d5b2', letterSpacing: 6, y: 600, height: 40 }),
    ],
  },
  {
    name: 'Food Special',
    category: 'Food',
    width: 1080,
    height: 1080,
    backgroundColor: '#6f1d1b',
    thumb: 'linear-gradient(#6f1d1b,#bb9457)',
    layers: [
      L({ type: 'shape', shape: 'ellipse', fill: '#bb9457', x: 90, y: 90, width: 900, height: 900, opacity: 0.2 }),
      L({ type: 'text', text: 'TONIGHT', fontFamily: 'Montserrat', fontSize: 24, fontWeight: '700', color: '#ffe6a7', letterSpacing: 12, y: 300, height: 40 }),
      L({ type: 'text', text: 'Truffle\nPasta', fontFamily: 'Playfair Display', fontSize: 96, fontWeight: '700', color: '#fff8e8', y: 360, height: 250, lineHeight: 1.05 }),
      L({ type: 'text', text: 'Chef’s table · 7PM', fontFamily: 'Montserrat', fontSize: 26, fontWeight: '500', color: '#ffe6a7', y: 720, height: 50 }),
    ],
  },
  {
    name: 'Fitness Hit',
    category: 'Fitness',
    width: 1080,
    height: 1080,
    backgroundColor: '#111111',
    thumb: 'linear-gradient(#111,#1b4332)',
    layers: [
      L({ type: 'shape', shape: 'rect', fill: '#00c853', x: 0, y: 0, width: 24, height: 1080 }),
      L({ type: 'text', text: 'NO EXCUSES', fontFamily: 'Anton', fontSize: 96, fontWeight: '400', color: '#ffffff', y: 380, height: 140, align: 'left', x: 80, width: 920 }),
      L({ type: 'text', text: '21-day challenge starts Monday', fontFamily: 'Montserrat', fontSize: 28, fontWeight: '500', color: '#00c853', y: 560, height: 50, align: 'left', x: 80, width: 920 }),
    ],
  },
  {
    name: 'Blush Fashion',
    category: 'Fashion',
    width: 1080,
    height: 1080,
    backgroundColor: '#fff0f3',
    thumb: 'linear-gradient(#fff0f3,#ffb3c1)',
    layers: [
      L({ type: 'shape', shape: 'ellipse', fill: '#ffb3c1', x: 420, y: 80, width: 760, height: 760, opacity: 0.55 }),
      L({ type: 'text', text: 'ROSE', fontFamily: 'Cormorant Garamond', fontSize: 140, fontWeight: '700', color: '#590d22', y: 400, height: 180 }),
      L({ type: 'text', text: 'atelier', fontFamily: 'Pacifico', fontSize: 48, fontWeight: '400', color: '#9e1946', y: 580, height: 80 }),
    ],
  },
  {
    name: 'Gold Launch',
    category: 'Business',
    width: 1080,
    height: 1080,
    backgroundColor: '#0b1320',
    thumb: 'linear-gradient(#0b1320,#c9a227)',
    layers: [
      L({ type: 'shape', shape: 'rect', fill: '#c9a227', x: 390, y: 220, width: 300, height: 4 }),
      L({ type: 'text', text: 'WE ARE LIVE', fontFamily: 'Raleway', fontSize: 28, fontWeight: '600', color: '#c9a227', letterSpacing: 12, y: 280, height: 50 }),
      L({ type: 'text', text: 'Studio\nOne', fontFamily: 'Playfair Display', fontSize: 110, fontWeight: '700', color: '#ffffff', y: 360, height: 280, lineHeight: 1 }),
      L({ type: 'text', text: 'A new chapter begins', fontFamily: 'Montserrat', fontSize: 24, fontWeight: '400', color: '#c9a227', y: 720, height: 40 }),
    ],
  },
  {
    name: 'Podcast Cover',
    category: 'Audio',
    width: 1080,
    height: 1080,
    backgroundColor: '#22223b',
    thumb: 'linear-gradient(#22223b,#4a4e69)',
    layers: [
      L({ type: 'shape', shape: 'ellipse', fill: '#9a8c98', x: 290, y: 160, width: 500, height: 500, opacity: 0.25 }),
      L({ type: 'text', text: 'EP 012', fontFamily: 'Montserrat', fontSize: 22, fontWeight: '700', color: '#c9ada7', letterSpacing: 8, y: 200, height: 40 }),
      L({ type: 'text', text: 'Late\nNight\nTalks', fontFamily: 'Oswald', fontSize: 92, fontWeight: '700', color: '#f2e9e4', y: 360, height: 340, lineHeight: 0.95, uppercase: true }),
    ],
  },
  {
    name: 'Event Night',
    category: 'Events',
    width: 1080,
    height: 1080,
    backgroundColor: '#9b2226',
    thumb: 'linear-gradient(#9b2226,#370617)',
    layers: [
      L({ type: 'text', text: 'SAT 09.12', fontFamily: 'Montserrat', fontSize: 24, fontWeight: '700', color: '#ffba08', letterSpacing: 8, y: 240, height: 40 }),
      L({ type: 'text', text: 'NIGHT\nMARKET', fontFamily: 'Anton', fontSize: 130, fontWeight: '400', color: '#ffffff', y: 320, height: 300, lineHeight: 0.95 }),
      L({ type: 'text', text: 'City Square  ·  6PM–12AM', fontFamily: 'Montserrat', fontSize: 26, fontWeight: '500', color: '#ffba08', y: 740, height: 40 }),
    ],
  },
  {
    name: 'Skincare',
    category: 'Beauty',
    width: 1080,
    height: 1080,
    backgroundColor: '#dad7cd',
    thumb: 'linear-gradient(#dad7cd,#a3b18a)',
    layers: [
      L({ type: 'shape', shape: 'ellipse', fill: '#a3b18a', x: 200, y: 180, width: 680, height: 680, opacity: 0.35 }),
      L({ type: 'text', text: 'GLOW', fontFamily: 'Cormorant Garamond', fontSize: 120, fontWeight: '700', color: '#344e41', y: 400, height: 160 }),
      L({ type: 'text', text: 'clean skin ritual', fontFamily: 'Montserrat', fontSize: 26, fontWeight: '500', color: '#3a5a40', y: 580, height: 40, letterSpacing: 4 }),
    ],
  },
  {
    name: 'Travel Postcard',
    category: 'Travel',
    width: 1080,
    height: 1080,
    backgroundColor: '#023e8a',
    thumb: 'linear-gradient(#023e8a,#90e0ef)',
    layers: [
      L({ type: 'shape', shape: 'ellipse', fill: '#90e0ef', x: -80, y: 640, width: 700, height: 700, opacity: 0.35 }),
      L({ type: 'text', text: 'WANDER', fontFamily: 'Bebas Neue', fontSize: 150, fontWeight: '400', color: '#caf0f8', y: 360, height: 180, letterSpacing: 10 }),
      L({ type: 'text', text: 'collect moments, not things', fontFamily: 'Dancing Script', fontSize: 42, fontWeight: '500', color: '#ffffff', y: 560, height: 70 }),
    ],
  },
  {
    name: 'YouTube Thumb',
    category: 'Video',
    width: 1280,
    height: 720,
    backgroundColor: '#111111',
    thumb: 'linear-gradient(90deg,#ff0000,#111)',
    layers: [
      L({ type: 'shape', shape: 'rect', fill: '#ff0000', x: 0, y: 0, width: 18, height: 720 }),
      L({ type: 'text', text: 'I TRIED THIS', fontFamily: 'Anton', fontSize: 92, fontWeight: '400', color: '#ffffff', y: 220, height: 130, align: 'left', x: 80, width: 1100 }),
      L({ type: 'text', text: 'FOR 30 DAYS', fontFamily: 'Anton', fontSize: 92, fontWeight: '400', color: '#ffd60a', y: 360, height: 130, align: 'left', x: 80, width: 1100 }),
    ],
  },
]

export const APPS = [
  { id: 'magic-write', icon: 'fa-magic', name: 'Magic Write', desc: 'AI writes headlines & captions' },
  { id: 'magic-fill', icon: 'fa-pen-fancy', name: 'Magic Fill', desc: 'Rewrite every text layer' },
  { id: 'bg', icon: 'fa-fill-drip', name: 'Background', desc: 'Solid colors & palettes' },
  { id: 'resize', icon: 'fa-expand-arrows-alt', name: 'Magic Resize', desc: 'Adapt to any format' },
  { id: 'brand', icon: 'fa-swatchbook', name: 'Brand Kit', desc: 'Colors, fonts, logos' },
]

export const HOME_LINKS = [
  { to: '/dashboard', icon: 'fa-home', label: 'Home' },
  { to: '/ai/studio', icon: 'fa-paint-brush', label: 'Projects' },
  { to: '/ai/assistant', icon: 'fa-robot', label: 'Agent Hub' },
  { to: '/posts/create', icon: 'fa-plus-circle', label: 'Create Post' },
  { to: '/posts', icon: 'fa-list', label: 'Posts' },
  { to: '/posts/approval', icon: 'fa-tasks', label: 'Approval' },
  { to: '/analytics', icon: 'fa-chart-bar', label: 'Analytics' },
  { to: '/social/accounts', icon: 'fa-instagram', brand: true, label: 'Accounts' },
]

export function hydrateLayers(layers, canvasW = 1080) {
  return (layers || []).map((raw) => {
    const layer = { ...raw, id: raw.id || uid() }
    if (layer.type === 'shape') return { ...shapeLayer(), ...layer, id: layer.id }
    if (layer.type === 'path') {
      return {
        id: layer.id,
        type: 'path',
        path: layer.path || '',
        fill: layer.fill || '#000000',
        viewBoxW: layer.viewBoxW || 64,
        viewBoxH: layer.viewBoxH || 64,
        x: layer.x || 0,
        y: layer.y || 0,
        width: layer.width || 64,
        height: layer.height || 64,
        rotation: layer.rotation || 0,
        opacity: layer.opacity == null ? 1 : layer.opacity,
        locked: !!layer.locked,
      }
    }
    if (layer.type === 'icon') return { ...iconLayer(), ...layer, id: layer.id }
    if (layer.type === 'video' || isVideoSrc(layer.src)) {
      return { ...videoLayer(layer.src || ''), ...layer, id: layer.id, type: 'video' }
    }
    if (layer.type === 'image') return { ...imageLayer(layer.src || ''), ...layer, id: layer.id }
    const t = { ...textLayer(), ...layer, id: layer.id }
    if (!t.width) t.width = Math.round(canvasW * 0.85)
    if (!t.height) t.height = Math.round((t.fontSize || 48) * 1.4)
    if (!t.verticalAlign) t.verticalAlign = 'center'
    return t
  })
}

export function fontFormat(url) {
  const u = String(url || '')
  if (u.includes('.woff2')) return 'woff2'
  if (u.includes('.woff')) return 'woff'
  if (u.includes('.otf')) return 'opentype'
  return 'woff2'
}

export function registerFontFace(font) {
  if (!font || !font.family || !font.url) return
  const weight = font.weight || '400'
  const style = font.style || 'normal'
  const faceKey = `${font.family}::${weight}::${style}::${font.url}`
  const id = `cv-font-${faceKey.replace(/[^a-zA-Z0-9]+/g, '-')}`
  if (document.getElementById(id)) return
  const el = document.createElement('style')
  el.id = id
  const fmt = fontFormat(font.url)
  el.textContent = `@font-face{font-family:'${font.family}';src:url('${font.url}') format('${fmt}');font-weight:${weight};font-style:${style};font-display:swap;}`
  document.head.appendChild(el)
}

export function mergeFontFamilies(base, library) {
  const out = base.slice()
  ;(library || []).forEach((font) => {
    if (font.family && out.indexOf(font.family) === -1) out.unshift(font.family)
  })
  return out
}

export function resolveLayerFont(layer, library) {
  if (!layer || layer.type !== 'text' || layer.fontUrl) return layer
  const weight = String(layer.fontWeight || '400')
  const style = layer.fontStyle || 'normal'
  const exact = (library || []).find((f) => (
    f.family === layer.fontFamily
    && String(f.weight || '400') === weight
    && (f.style || 'normal') === style
  ))
  const loose = (library || []).find((f) => f.family === layer.fontFamily)
  const face = exact || loose
  if (!face) return layer
  return {
    ...layer,
    fontUrl: face.url,
    fontWeight: face.weight || weight,
    fontStyle: face.style || style,
  }
}

export function applyLibraryToPages(pages, library) {
  return (pages || []).map((page) => ({
    ...page,
    layers: (page.layers || []).map((layer) => resolveLayerFont(layer, library)),
  }))
}

export function blankPage(width = 1080, height = 1080, backgroundColor = '#ffffff') {
  return {
    id: uid('pg'),
    width,
    height,
    backgroundColor,
    backgroundUrl: '',
    backgroundVideoUrl: '',
    layers: [],
  }
}

function hasMedia(layers, type, src) {
  return (layers || []).some((l) => l.type === type && l.src === src)
}

export function materializeBackground(page) {
  const w = page.width || 1080
  const h = page.height || 1080
  const layers = page.layers ? page.layers.slice() : []
  if (page.backgroundVideoUrl && !hasMedia(layers, 'video', page.backgroundVideoUrl)) {
    layers.unshift(videoLayer(page.backgroundVideoUrl, { x: 0, y: 0, width: w, height: h }))
  }
  if (page.backgroundUrl && !hasMedia(layers, 'image', page.backgroundUrl)) {
    layers.unshift(imageLayer(page.backgroundUrl, { x: 0, y: 0, width: w, height: h }))
  }
  page.layers = layers
  page.backgroundUrl = ''
  page.backgroundVideoUrl = ''
  return page
}

export function pagesFromCanvaImport(imported) {
  const rawPages = imported.pages && imported.pages.length ? imported.pages : null
  if (rawPages) {
    return rawPages.map((p) => {
      const page = blankPage(p.width || imported.width, p.height || imported.height, p.backgroundColor || imported.background_color || '#ffffff')
      page.backgroundUrl = p.backgroundUrl || p.background_url || ''
      page.backgroundVideoUrl = p.backgroundVideoUrl || p.background_video_url || ''
      page.layers = hydrateLayers(p.layers || [], page.width)
      return materializeBackground(page)
    })
  }
  const page = blankPage(imported.width || 1080, imported.height || 1080, imported.background_color || '#ffffff')
  if (imported.layers && imported.layers.length) {
    page.layers = hydrateLayers(imported.layers, page.width)
  } else if (imported.url) {
    page.backgroundUrl = imported.url
  }
  return [materializeBackground(page)]
}

export function applyTemplate(tpl) {
  return {
    id: uid('pg'),
    width: tpl.width,
    height: tpl.height,
    backgroundColor: tpl.backgroundColor,
    backgroundUrl: '',
    layers: hydrateLayers(clone(tpl.layers).map((l) => ({ ...l, id: uid() })), tpl.width, tpl.height),
  }
}

export function defaultDoc() {
  const page = applyTemplate(STARTER_TEMPLATES[4])
  return { version: 2, pages: [page] }
}

export function parseDocument(raw, template) {
  const width = template?.width || 1080
  const height = template?.height || 1080
  const bgUrl = template?.background_url || ''
  if (!raw) {
    return { version: 2, pages: [materializeBackground({ ...blankPage(width, height), backgroundUrl: bgUrl })] }
  }
  let data = raw
  if (typeof raw === 'string') {
    try { data = JSON.parse(raw) } catch (e) { data = [] }
  }
  if (data && data.pages && Array.isArray(data.pages)) {
    return {
      version: 2,
      canvaSourceUrl: data.canva_source_url || data.canvaSourceUrl || '',
      pages: data.pages.map((p) => materializeBackground({
        id: p.id || uid('pg'),
        width: p.width || width,
        height: p.height || height,
        backgroundColor: p.backgroundColor || '#ffffff',
        backgroundUrl: p.backgroundUrl || '',
        backgroundVideoUrl: p.backgroundVideoUrl || '',
        layers: hydrateLayers(p.layers, p.width || width, p.height || height),
      })),
    }
  }
  const layers = Array.isArray(data) ? data : []
  return {
    version: 2,
    canvaSourceUrl: data.canva_source_url || data.canvaSourceUrl || '',
    pages: [materializeBackground({
      id: uid('pg'),
      width,
      height,
      backgroundColor: template?.backgroundColor || '#ffffff',
      backgroundUrl: bgUrl || template?.backgroundUrl || '',
      layers: hydrateLayers(layers, width, height),
    })],
  }
}

export function layerCssFilter(layer) {
  if (layer.type !== 'image' && layer.type !== 'video') return 'none'
  if (layer.filter === 'grayscale') return 'grayscale(1)'
  if (layer.filter === 'sepia') return 'sepia(0.85)'
  if (layer.filter === 'contrast') return 'contrast(1.35) saturate(1.1)'
  return `brightness(${(layer.brightness || 100) / 100}) contrast(${(layer.contrast || 100) / 100}) saturate(${(layer.saturate || 100) / 100})`
}
